var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_c('div',{staticClass:"title-wrapper"},[_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$isCN() ? _vm.title : _vm.titleEN)+"\n      "),_c('div',{staticClass:"bg"})]),(_vm.$isCN())?_c('div',{staticClass:"title-en"},[_vm._v(_vm._s(_vm.titleEN))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47e062e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionTitle.vue
// module id = YvzC
// module chunks = 0 1 2 3 5 6 7